/**
 * This file will bind JS needed to submit email alert forms. e.g. those used
 * in _email-alert-dirp.hero, _email-apply-modal.hero, and _email-alert-tile.hero and _job-2pane-job-email-alert.hero.
 *
 * Example Usage:
 *  <form action="/candidate/create-from-search" data-js-select="email_alert_form" method="post">
 *    <input name="submitted" type="hidden" value="1">
 *    <input name="form_type" type="hidden" value="candidate/_modal_create_alert_from_search">
 *    <input name="search" type="hidden" value="<%= p.EmailAlert.Title %>">
 *    <input name="location" type="hidden" value="<%= p.EmailAlert.Location %>">
 *    <input name="method" type="hidden" value="...">
 *    <input name="next_url" type="hidden" value="/candidate/search?search=<%= p.EmailAlert.URLTitle %>">
 *    <input name="request_url" type="hidden" value="/Jobs/<%= p.EmailAlert.URLTitle %>">
 *    <input name="radius" type="hidden" value="<%=i p.EmailAlert.NationalSearchRadiusMiles %>">
 *
 *    <input name="email_address" type="email" required data-js-select="email_address" aria-describedby="email_alert_callback">
 *    <button type="submit" name="submit" data-js-select="submit">Get Notified</button>
 *    <div id="email_alert_callback" data-js-select="email_alert_callback" style="display: none;" aria-live="polite"></div>
 *  <form>
 */

import { apiRequest } from '@zr/utilities/api';

let $emailAlertForm;
let $submit;
let $emailInput;
let $emailAlertOpen;
let $form;

const hideEmailAlertFormStatus = () => {
  $form?.find('[data-js-select="email_alert_callback"]').text('').css('visibility', 'hidden');
};

const showEmailAlertFormStatus = (txt) => {
  $form?.find('[data-js-select="email_alert_callback"]').text(txt).css('visibility', 'visible');
};

const hideEmailAlertForm = () => {
  setTimeout(() => {
    const $emailAlertSection = $('#email_alert_section');

    if ($emailAlertSection && zr.page.model.isMobile) {
      $emailInput.val('');
      $emailAlertOpen.show();
      $('#terms').hide();
      $('#email_alert_form').hide();
    }
  }, 3000);
};

const setErrorState = (message) => {
  showEmailAlertFormStatus(message);
  $form?.find('[data-js-select="submit"]').removeAttr('disabled');
  $form?.find('[data-js-select="email_address"]').attr('aria-invalid', '').addClass('error').focus();

  hideEmailAlertForm();
};

const zrIsValidURLOrPath = (url) => url && (url.match(/^(https?:\/\/|\/)/i) ? 1 : 0);

export const initEmailAlertForm = () => {
  $emailAlertForm = $('[data-js-select="email_alert_form"]');
  $submit = $emailAlertForm.find('[data-js-select="submit"]');
  $emailInput = $emailAlertForm.find('[data-js-select="email_address"]');
  $emailAlertOpen = $('[data-open-email-alert-modal]');
  const { canApplyOnZr } = zr.page.model;

  // mobile version
  $emailAlertOpen.on('click', () => {
    $emailAlertOpen.hide();
    $('#terms').show();
    $('#email_alert_form').show();
  });


  $emailAlertForm.on('submit', async (e) => {
    $.log_event('button_click', { field: 'dirp_cta_continue' });
    e.preventDefault();

    $form = $(e.target);

    // Update DOM to prepare for submit.
    showEmailAlertFormStatus('Processing...');
    $submit.removeAttr('disabled');

    const postUrl = $form.attr('action');
    const postData = $form.serialize();

    const fetchInit = {
      method: 'POST',
      body: postData,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    };
    // For external jobs, also open external apply URL in a new tab.
    const extApplyURL = $emailAlertForm.data('ext-apply-url') || zr.page.model.applyNowHref;
    if (extApplyURL && extApplyURL !== '' && !canApplyOnZr) {
      window.open(extApplyURL, '_blank', 'noreferrer');
    }

    try {
      const resp = await apiRequest(postUrl, fetchInit, '', true);
      const data = await resp.json();

      if (data.status === 'success') {
        if (zrIsValidURLOrPath(data.redirect_url)) {
          window.location = data.redirect_url;
        } else {
          showEmailAlertFormStatus('Login successful, reloading page...');
          window.location.reload();
        }
      } else if (data.error_type === 'email_exists') {
        hideEmailAlertFormStatus();
        $.log_event('failed_reg', { hero: 1, name: 'auto_banner_show' });
        // Show the "email exists" modal, if it's on the page.
        const $emailAlertSection = $('#email_alert_section');
        if ($emailAlertSection.length > 0) {
          const $emailExists = $('[data-state="email-exists"]');
          if ($emailExists.length > 0) {
            $emailAlertSection.css('z-index', 1);
            $emailExists.modal('show');
          } else {
            setErrorState('Email already exists.');
          }
        } else {
          const $emailExists = $('[data-modal-state] [data-state="email-exists"]');
          if ($emailExists.length > 0) {
            const $emailAlertModal = $emailExists.closest('[data-modal-state]');
            $emailAlertModal.attr('data-modal-state', 'email-exists');
            $emailAlertModal.modal('show');
          } else {
            setErrorState('Email already exists.');
          }
        }
      } else {
        // other error message
        setErrorState(data.message);
      }
    } catch (err) {
      setErrorState('Could not submit the form at this moment. Try again.');
    }
  });

  $emailInput.on('input', () => {
    $emailInput.removeClass('error').removeAttr('aria-invalid');
    hideEmailAlertFormStatus();
  });
};

export default initEmailAlertForm;
